import { Header, BottomNav } from "../components/Header";
import NotificationsContent from "../components/NotificationsContent";

const NotificationsPage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF9] pb-20 md:pb-8">
      <Header />
      <main className="max-w-2xl mx-auto px-4 py-6">
        <NotificationsContent />
      </main>
      <BottomNav />
    </div>
  );
};

export default NotificationsPage;
